import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { GetAccess } from "../../../Components/Utils/roles";
import SearchBar from "../../../Components/Utils/SearchBar";
import { Select } from "antd";
import { useNumber } from "../../../Context/ProjectIdContext";
import axiosInstance from "../../../Services/axiosCommon";
import { CreateButton } from "../../../Components/Utils/Buttons";

function HRViewLayout({
  children,
  setSearchQuery = () => {},
  searchQuery = "",
  getData = () => {},
  CreateAccess = "",
  setOpen = () => {},
}) {
  let { officeId } = useParams();
  let { pathname } = useLocation();
  const { number, updateNumber } = useNumber();
  const [projectList, setProjectList] = useState([]);
  const [module,setModule] = useState("")
  let LinkItem = [
    {
      label: "Attendance",
      link: `/main/${officeId}/hr/attendance`,
      access: GetAccess(),
    },
    {
      label: "Timesheets",
      link: `/main/${officeId}/hr/timesheets`,
      access: GetAccess(),
    },
    {
      label: "Team",
      link: `/main/${officeId}/hr/team`,
      access: GetAccess(),
    },
  ];
  function getProjectByOffice(id) {
    axiosInstance
      .get(`/DropDown/${id}/getAllProjects`)
      .then((res) => {
        let tempValue = res?.data?.data || [];
        let arr = [];
        tempValue.map((i) => {
          let val = {
            value: i?.projId || "",
            label: i?.projName || "",
          };
          arr.push(val);
        });
        if (number == 0) {
          updateNumber(arr[0]?.value);
        }
        setProjectList(arr);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  useEffect(() => {
    if (number == 0 || pathname != "") getProjectByOffice(officeId);
  }, [pathname]);

  function handleProjectChange(e) {
    console.log(e);
    updateNumber(e);
  }

      useEffect(() =>{
          if(pathname == `/main/${officeId}/hr/attendance`){
              setModule("Attendance")
          }else if(pathname == `/main/${officeId}/hr/timesheets`){
              setModule("Timesheets")
          }
          else if(pathname == `/main/${officeId}/hr/team`){
              setModule("team")
          }
      },[pathname])

  return (
    <div className=" w-full h-full py-2 px-4 ">
      <div className="md:flex justify-between w-full">
        <div className=" w-full h-8 flex items-center gap-x-4 ">
          {LinkItem &&
            LinkItem.map((item, i) => {
              return (
                <>
                  {item.access && (
                    <Link
                      to={item?.link}
                      className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${
                        item?.link == pathname
                          ? "border-b-2 border-baseColor-primary"
                          : "border-b-2 border-transparent"
                      }   `}
                      key={item?.link}
                    >
                      {item?.label || ""}
                    </Link>
                  )}
                </>
              );
            })}
        </div>
        <div className=" flex justify-end items-center gap-3 mr-6">
          <div>
            <SearchBar value={searchQuery} handleChange={(e) => setSearchQuery(e.target.value)} />
          </div>
          <form
            className=" w-48 flex justify-end items-center xl:gap-3 mx-0"
            onSubmit={getData}
          >
            <Select
              style={{ width: "100%" }}
              options={projectList}
              value={number}
              disabled={projectList.length >= 2 ? false : true}
              onChange={handleProjectChange}
            />
          </form>
          {CreateAccess && (
            <div className=" flex items-center gap-2">
              <CreateButton label="Team" handleClick={() => setOpen(true)} />
            </div>
          )}
        </div>
      </div>
      <div className=" rounded-md w-full h-[calc(100vh-140px)] bg-white mt-2">
      {children}
      </div>
    </div>
  );
}

export default HRViewLayout;
